module.exports = __webpack_public_path__ + "a448006bd1a980ba37c1e4e9c6e9c815.pdf";